import { render, staticRenderFns } from "./LibraryCard.vue?vue&type=template&id=aa0a7d70&scoped=true"
import script from "./LibraryCard.vue?vue&type=script&lang=js"
export * from "./LibraryCard.vue?vue&type=script&lang=js"
import style0 from "./LibraryCard.vue?vue&type=style&index=0&id=aa0a7d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0a7d70",
  null
  
)

export default component.exports